<template>
  <div class="sub-team-data">
    <div class="main">
      <div class="troops">
        <div class="troops-box">
          <div class="blue">大连梦之队</div>
          <div class="red">众智篮球队</div>
          <div class="vs">VS</div>
        </div>
      </div>
      <div class="shoot">
        <div class="title">投篮表现</div>
        <div class="shoot-data">
          <div class="chart">
            <my-echarts :eWidth="250" :eHight="250" :option="options" />
          </div>
          <div class="line-box">
            <div class="line-item" v-for="i in 6" :key="i" :style="{ marginBottom: i == 5 || i == 6 ? '' : '20px' }">
              <div class="name">2分命中率</div>
              <div class="line-red">
                <div class="gray">
                  <div class="red"></div>
                </div>
                <div class="percent">52%</div>
                <div class="score">75/121</div>
              </div>
              <div class="line-blue">
                <div class="gray">
                  <div class="blue"></div>
                </div>
                <div class="percent">52%</div>
                <div class="score">75/121</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="team-data">
        <div class="left">
          <div class="title">篮板表现</div>
          <div class="pie-list">
            <pie-echart :options="options1" v-for="i in 3" :key="i" />
          </div>
        </div>
        <div class="right">
          <div class="title">关键数据</div>
          <div class="hinge">
            <div class="hinge-line" v-for="i in 4" :key="i">
              <div class="hinge-left"><span class="info">54.3%</span><span class="l-score">27</span></div>
              <div class="hinge-name">助攻{{i}}</div>
              <div class="hinge-ritht"><span class="r-score">23</span><span class="info">54.3%</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import myEcharts from '@comm/components/modal/myecharts/MyEcharts.vue'
import pieEchart from './BasketballPieEchart.vue'
export default {
  name: 'BasketballTeamData',
  props: {},
  data() {
    return {
      options: {
        color: ['#F2F2F2', '#FF7815'],
        silent: true,
        series: [
          {
            name: '123',
            type: 'pie',
            radius: ['82%', '100%'],
            color: ['#FF7815', '#F2F2F2'],
            label: {
              show: false,
            },
            data: [
              { value: 110, name: '111' },
              { value: 90, name: 'F2F2F2' },
            ],
          },
          {
            name: '234',
            type: 'pie',
            radius: ['58%', '76%'],
            color: ['#0073D5', '#F2F2F2'],
            label: {
              show: false,
            },
            data: [
              { value: 100, name: '999' },
              { value: 120, name: '333' },
            ],
          },
        ],
      },
      options1: {
        color: ['#0073D5', '#FF7815'],
        silent: true,
        series: [
          {
            name: '123',
            type: 'pie',
            radius: ['82%', '100%'],
            // color: ['#FF7815', '#0073D5'],
            label: {
              show: false,
            },
            data: [
              { value: 110, name: '111' },
              { value: 90, name: 'F2F2F2' },
            ],
          },
        ],
      },
    }
  },
  components: { myEcharts, pieEchart },
  mounted() {},
  methods: {
    blueWidth(item) {
      let obj = {
        width: 0,
      }
      score
      return
    },
    blueWidth(item) {},
  },
  watch: {},
}
</script>

<style scoped lang="scss">
.sub-team-data {
  width: 100%;
  background-color: #f8f8f8;
  padding-bottom: 30px;
  .main {
    width: 1200px;
    margin: 0 auto;
    .troops {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 25px 0;
      .troops-box {
        width: 403px;
        height: 50px;
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-weight: bold;
        font-size: 18px;
        color: #fff;
        .blue {
          width: 200px;
          line-height: 50px;
          text-align: center;
          background-color: #0073d5;
          margin-right: 2px;
        }
        .red {
          width: 200px;
          line-height: 50px;
          text-align: center;
          background-color: #ff7815;
        }
        .vs {
          position: absolute;
          top: 50%;
          left: 50%;
          font-size: 36px;
          font-weight: bold;
          transform: translate(-50%, -50%);
        }
      }
    }
    .title {
      font-size: 18px;
      font-weight: bold;
    }
    .shoot {
      width: 1200px;
      margin: 0 auto;
      height: 310px;
      background: #fff;
      box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.12);
      border-radius: 10px;
      margin-bottom: 20px;
      padding: 15px 30px;
      box-sizing: border-box;

      .shoot-data {
        display: flex;
        justify-content: flex-start;
        height: 250px;
        box-sizing: border-box;
        .chart {
          width: 250px;
          height: 250px;
          margin-right: 30px;
          box-sizing: border-box;
        }
        .line-box {
          width: 900px;
          display: flex;
          height: 250px;
          justify-content: space-between;
          align-content: flex-start;
          box-sizing: border-box;
          flex-wrap: wrap;
          box-sizing: border-box;
          margin-top: -10px;
        }
        .line-item {
          width: 420px;
          height: 70px;
          .name {
            font-size: 16px;
            font-weight: bold;
          }
          .line-red {
            width: 410px;
            height: 15px;
            margin-top: 8px;
            box-sizing: border-box;
            display: flex;
            justify-content: space-between;
            line-height: 15px;
            .gray {
              width: 300px;
              background-color: #f2f2f2;
              position: relative;
              height: 100%;
              .red {
                width: 300px;
                background-color: #ff7815;
                position: absolute;
                top: 0;
                left: 0;
                height: 100%;
              }
            }
            .percent {
              width: 50px;
              text-align: center;
              font-weight: bold;
              color: #333;
              font-size: 16px;
              line-height: 15px;
            }
            .score {
              width: 60px;
              font-size: 14px;
              color: #999999;
              line-height: 15px;
            }
          }
          .line-blue {
            width: 410px;
            height: 15px;
            margin-top: 8px;
            box-sizing: border-box;
            display: flex;
            justify-content: flex-start;
            .gray {
              width: 300px;
              background-color: #f2f2f2;
              position: relative;
              height: 100%;
              .blue {
                width: 300px;
                background-color: #0073d5;
                position: absolute;
                left: 0;
                top: 0;
                height: 100%;
              }
            }
            .percent {
              width: 50px;
              text-align: center;
              font-weight: bold;
              color: #333;
              font-size: 16px;
              line-height: 15px;
            }
            .score {
              width: 60px;
              font-size: 14px;
              color: #999999;
              line-height: 15px;
            }
          }
        }
      }
    }
    .team-data {
      display: flex;
      justify-content: space-between;
      .left {
        width: 590px;
        height: 310px;
        box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.12);
        background-color: #fff;
        border-radius: 10px;
        padding: 20px 30px;
        box-sizing: border-box;
        .pie-list {
          padding-top: 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
      }
      .right {
        width: 590px;
        height: 310px;
        box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.12);
        background-color: #fff;
        border-radius: 10px;
        padding: 20px 30px;
        box-sizing: border-box;
        .hinge {
          padding-top: 10px;
          .hinge-line {
            display: flex;
            justify-content: center;
            height: 40px;
            line-height: 40px;
            margin-bottom: 15px;
            .l-score {
              font-size: 24px;
              font-weight: bold;
              margin-left: 20px;
              line-height: 40px;
            }
            .info {
              font-size: 14px;
              color: #999;
              line-height: 40px;
            }
            .hinge-name {
              width: 140px;
              text-align: center;
              font-size: 16px;
              font-weight: bold;
              border-radius: 80px;
              background-color: #f2f2f2;
              margin: 0 20px;
            }
            .r-score {
              font-size: 24px;
              font-weight: bold;
              margin-right: 20px;
              line-height: 40px;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/comm/components/match/basketball/components/BasketballTeamData.vue